module.exports = __webpack_public_path__ + "media/lifestyle_home/kantroright-e835aff7.png";